import Api from "api";

export const getProfile = async () => {
  try {
    const { data } = await Api.get("/account/profile", {});
    return {
      data: {
        id: data.data.id,
        ...data.data.attributes,
      },
    };
  } catch (e: any) {
    const errorMsg =
      (e &&
        e.response &&
        e.response.data &&
        e.response.data.messages &&
        e.response.data.messages[0]) ||
      "Failed to Fetch Profile";
    return {
      error: e.toString(),
    };
  }
};

export const getCustomerPortalSession = async () => {
  try {
    const { data } = await Api.get("/subscriptions/customer_portal", {});
    return {
      data
    };
  } catch (e: any) {
    const errorMsg =
      (e &&
        e.response &&
        e.response.data &&
        e.response.data.messages &&
        e.response.data.messages[0]) ||
      "Failed to Fetch customer session";
    return {
      error: errorMsg
    };
  }
};

export const deleteCollection = async (id) => {
  try {
    const { data } = await Api.delete(`/collections/${id}`);
    return {
      data: data && data.messages ? data.messages[0] : '',
    };
  } catch (e: any) {
    const errorMsg =
      (e &&
        e.response &&
        e.response.data &&
        e.response.data.messages &&
        e.response.data.messages[0]) ||
      "Failed to Delete collection item";
    return {
      error: errorMsg
    };
  }
};

export const cloneCollection = async (id, name) => {
  try {
    const { data } = await Api.get(`/collections/${id}/clone`, { name });
    return {
      data: data && data.data ? data.data : {},
    };
  } catch (e: any) {
    const errorMsg =
      (e &&
        e.response &&
        e.response.data &&
        e.response.data.messages &&
        e.response.data.messages[0]) ||
      "Failed to Clone collection";
    return {
      error: errorMsg
    };
  }
};

export const addCollectionItem = async (collectionId, params) => {
  try {
    const { data } = await Api.post(`/collections/${collectionId}/add_item`, params);
    return {
      data
    };
  } catch (e: any) {
    const errorMsg =
      (e &&
        e.response &&
        e.response.data &&
        e.response.data.messages &&
        e.response.data.messages[0]) ||
      "Failed to Fetch";
    return {
      error: errorMsg
    };
  }
};

export const deleteCollectionItem = async (collectionId, itemId, params) => {
  try {
    const { data } = await Api.delete(`/collections/${collectionId}/item/${itemId}?type=${params.type}`);
    return {
      data
    };
  } catch (e: any) {
    console.log(e);
    const errorMsg =
      (e &&
        e.response &&
        e.response.data &&
        e.response.data.messages &&
        e.response.data.messages[0]) ||
      "Failed to Fetch";
    return {
      error: errorMsg
    };
  }
};

export const addItemNote = async (collectionId, item_id, note, type) => {
  try {
    const { data } = await Api.post(`/collections/${collectionId}/update_item`, {
      item_id,
      note,
      type
    });
    return {
      data
    };
  } catch (e: any) {
    console.log(e);
    const errorMsg =
      (e &&
        e.response &&
        e.response.data &&
        e.response.data.messages &&
        e.response.data.messages[0]) ||
      "Failed to Fetch";
    return {
      error: errorMsg
    };
  }
};

export const getExportCheckoutSession = async (collectionId) => {
  try {
    const { data } = await Api.get(`/payments/checkout_session/${collectionId}`, {});
    return {
      data
    };
  } catch (e: any) {
    const errorMsg =
      (e &&
        e.response &&
        e.response.data &&
        e.response.data.messages &&
        e.response.data.messages[0]) ||
      "Failed to create checkout session";
    return {
      error: errorMsg
    };
  }
};

export const getExportStatus = async (collectionId) => {
  try {
    const { data } = await Api.get(`/export/status/${collectionId}`, {});
    return {
      data
    };
  } catch (e: any) {
    return {
      error: "Failed to check export status"
    };
  }
};

export const userActions = {
  merge: "merge",
  duplicate: "duplicate",
  collaborate: "collaborate",
  clone: "clone",
  upload_excel_file: "upload_excel_file",
  download: "download",
  generate_pdf: "generate_pdf",
};

export const checkUserCan = (user, action) => {
  if (!user) {
    return false;
  }
  const isPaid = user.status !== "free";
  const actionChecks = {
    merge: user.can_export ?? isPaid,
    duplicate: user.can_export ?? isPaid,
    collaborate: user.can_collaborate ?? (user.status === "enterprise"),
    clone: user.can_export ?? isPaid,
    upload_excel_file: user.can_upload ?? isPaid,
    download: user.can_export ?? isPaid,
    generate_pdf: user.can_generate_target_pdf ?? isPaid,
  };

  return !!actionChecks[action];
};
